import {Component} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-reason',
  templateUrl: './reason.component.html',
  styleUrls: ['./reason.component.scss']
})
export class ReasonComponent {
  public defaultReasons: string[] = ['Санек','Что','Писать','В', 'Причинах', 'Бана?'];

  public reason: FormControl = new FormControl<string>('', [Validators.required])

  constructor(private dialogRef: MatDialogRef<ReasonComponent>) {
  }

  public cancelPayout(): void {
    this.dialogRef.close(this.reason.value)
  }

  public close(): void {
    this.dialogRef.close(false);
  }

}
